import { render, staticRenderFns } from "./OrdenesGrid.vue?vue&type=template&id=f11d2d9a&scoped=true&"
import script from "./OrdenesGrid.vue?vue&type=script&lang=js&"
export * from "./OrdenesGrid.vue?vue&type=script&lang=js&"
import style0 from "./OrdenesGrid.vue?vue&type=style&index=0&id=f11d2d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11d2d9a",
  null
  
)

export default component.exports